export default {
  groupName: 'ford-us-growth',
  appName: 'Ford US Focus Audience',
  isAuto: true,
  baseRoute: '/ford-us-growth',
  image: 'ford.png',
  description:
    'Ford - US Focus Audience Advertising Dashboard'
}



// WEBPACK FOOTER //
// ./src/app/configuration/FordUSGrowth/config/main.js